import type { ProductFormValues, ServiceCatalogFormValues } from '@oficina/shared';
import { api } from '@/lib/api';
import type { CatalogReference, Paginated, Product, RemovalResult, ServiceCatalogItem } from '@/types/api';

export type CatalogReferenceKind = 'categories' | 'brands' | 'suppliers';
export const catalogReferencesService = {
  list: (kind: CatalogReferenceKind, includeInactive = false, signal?: AbortSignal) =>
    api.get<Paginated<CatalogReference>>(`/catalog-references/${kind}`, { pageSize: 500, includeInactive }, signal),
  create: (kind: CatalogReferenceKind, name: string) => api.post<CatalogReference>(`/catalog-references/${kind}`, { name }),
  update: (kind: CatalogReferenceKind, id: string, input: { name?: string; active?: boolean }) =>
    api.patch<CatalogReference>(`/catalog-references/${kind}/${id}`, input),
  remove: (kind: CatalogReferenceKind, id: string) => api.delete<RemovalResult>(`/catalog-references/${kind}/${id}`),
};

export interface CatalogListParams {
  search?: string;
  includeInactive?: boolean;
  lowStock?: boolean;
  /** Somente componentes: filtra por tipo. */
  typeId?: string;
  page?: number;
  pageSize?: number;
}

export const productsService = {
  list: (params: CatalogListParams = {}, signal?: AbortSignal) =>
    api.get<Paginated<Product>>('/products', { pageSize: 500, ...params }, signal),
  create: (input: ProductFormValues) => api.post<Product>('/products', input),
  update: (id: string, input: Partial<ProductFormValues>) => api.patch<Product>(`/products/${id}`, input),
  remove: (id: string) => api.delete<RemovalResult>(`/products/${id}`),
};

export const servicesService = {
  list: (params: CatalogListParams = {}, signal?: AbortSignal) =>
    api.get<Paginated<ServiceCatalogItem>>('/services', { pageSize: 500, ...params }, signal),
  create: (input: ServiceCatalogFormValues) => api.post<ServiceCatalogItem>('/services', input),
  update: (id: string, input: Partial<ServiceCatalogFormValues>) =>
    api.patch<ServiceCatalogItem>(`/services/${id}`, input),
  remove: (id: string) => api.delete<RemovalResult>(`/services/${id}`),
};
